import validator from "validator";
import moment from "moment";

// Utils
import { isEmpty, removeSpacesAndHTML } from "../general.utils";
import { doesRoleExist } from "../roles.utils";

// Constants
import { UserRolesKeysEnum } from "../../constants/roles.constants";
import i18next from "i18next";

const allowedDateFormats = [
  "DD/MM/YYYY",
  "D/M/YYYY",
  "DD.MM.YYYY",
  "D.M.YYYY",
  "DD-MM-YYYY",
  "D-M-YYYY"
];

const validateDate = value => moment(value, allowedDateFormats, true).isValid();

export const addUserFormValidation = ({
  firstName,
  lastName,
  email,
  bornDate,
  firstDayAtWork,
  roles,
  tier,
  companyId,
  cities
}) => {
  const errors = {};

  if (!roles) errors.roles = i18next.t("required_field");

  if (!firstName || !/\S/.test(firstName))
    errors.firstName = i18next.t("required_field");
  else if (!removeSpacesAndHTML(firstName)) {
    errors.firstName = i18next.t("html_tag_ban");
  }

  if (!lastName || !/\S/.test(lastName))
    errors.lastName = i18next.t("required_field");
  else if (!removeSpacesAndHTML(lastName)) {
    errors.lastName = i18next.t("html_tag_ban");
  }

  if (!email) errors.email = i18next.t("required_field");
  else if (!validator.isEmail(email)) errors.email = i18next.t("invalid_email");

  if (
    doesRoleExist(roles, UserRolesKeysEnum.MEMBER) ||
    doesRoleExist(roles, UserRolesKeysEnum.HR)
  ) {
    if (!companyId) errors.companyId = i18next.t("required_field");
  }

  if (doesRoleExist(roles, UserRolesKeysEnum.MEMBER) && isEmpty(cities)) {
    errors.cities = i18next.t("required_field");
  }

  if (doesRoleExist(roles, UserRolesKeysEnum.MEMBER)) {
    if (isEmpty(cities)) {
      errors.cities = i18next.t("required_field");
    }

    if (typeof tier === Object) {
      if (tier.id === null) {
        errors.tier = i18next.t("required_field");
      }
    } else {
      if (!tier) {
        errors.tier = i18next.t("required_field");
      }
    }
  }

  return errors;
};
